import { request } from "../helpers/axios.new";

export const FETCH_QUOTES = () => {
  return request({
    url: `/quotes`,
    method: "GET",
  });
};
